import React, { Component } from "react";
import classnames from "classnames";
import ReactDOM from "react-dom";
import { isFunction } from "@platform/api";
import HotKeys from "../HotKeys";
import { getSysFieldid } from "@platform/api";

require("./index.less");

export default class Sidebox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        // this.html = null;
    }

    componentDidMount() {
        // this.html = document.getElementsByTagName("html");
        let { show } = this.props;
        document.body.style.overflow = show ? 'hidden' : '';
    }

    shouldComponentUpdate() {
        let { show } = this.props;
        document.body.style.overflow = show ? 'hidden' : '';
        return true;
    }

    componentWillUnmount() {
        // if (this.html && this.html[0]) {
        //     this.html[0].style.overflow = "";
        // }
        document.body.style.overflow = '';
    }

    render() {
        const {
            mask,
            show,
            style,
            maskClose,
            className,
            title,
            onClose,
            showButton,
            buttonClick,
            width,
            propContainer,
            buttonDisabled = [],
            getHeaderBtns,
        } = this.props;
        let classname = "sidebox " + (className || "");
        // if (this.html && this.html[0]) {
        //     if (show && mask) {
        //         this.html[0].style.overflow = "hidden";
        //     } else {
        //         this.html[0].style.overflow = "";
        //     }
        // }

        return ReactDOM.createPortal(
            show && (
                <section style={style} className={classname}>
                    {mask && (
                        <div
                            className="sidebox-mask"
                            onClick={() => {
                                isFunction(maskClose) && maskClose();
                            }}
                        />
                    )}
                    <HotKeys
                        keyMap={{ colse: "f4" }}
                        handlers={{
                            colse: () => {
                                this.setState({ show: false });
                            },
                        }}
                        className="close-hotkeys-wrapper"
                        focused={true}
                        display="inline"
                    />
                    <div
                        className="sidebox-content disabled-bg-btn"
                        style={propContainer ? { width, position: 'absolute' } : { width }}
                        fieldid={getSysFieldid("sidebox_modal-area")}
                    >
                        <div
                            className="sidebox-header"
                            fieldid={getSysFieldid("header-area")}
                        >
                            <span
                                className="sidebox-title"
                                fieldid={getSysFieldid(`${title}_title`)}
                            >
                                {title}
                            </span>
                            <span className="goto-opre">
                                <span className="custom-button-area">{typeof getHeaderBtns === 'function' && getHeaderBtns()}</span>
                                {showButton && (
                                    <span className="icon-wrapper">
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-shangyiye first",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[0],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("first");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-jiantouzuo prev",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[1],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("prev");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-jiantouyou next",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[2],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("next");
                                            }}
                                        />
                                        <span
                                            className={classnames(
                                                "icon iconfont icon-xiayiye end",
                                                {
                                                    "cannot-click":
                                                        buttonDisabled[3],
                                                },
                                            )}
                                            onClick={() => {
                                                isFunction(buttonClick) &&
                                                    buttonClick("end");
                                            }}
                                        />
                                    </span>
                                )}

                                <span
                                    className="icon iconfont icon-you icon-celashouqi"
                                    onClick={onClose}
                                />
                            </span>
                        </div>
                        <div className="sidebox-body">
                            {this.props.children}
                        </div>
                    </div>
                </section>
            ),
            propContainer || document.querySelector("body"),
        );
    }
}
